import Error500Page from './Error500Page'

export default Error500Page
